export default __webpack_public_path__ + "static/media/RIGHT-P14-3-2mm.06b356f9.dwg";